import api from "lib/api/api";
import {
  FETCH_CATALOG_FAILURE,
  FETCH_CATALOG_REQUEST,
  FETCH_CATALOG_SUCCESS,
  FETCH_COURSE_DETAILS_FAILURE,
  FETCH_COURSE_DETAILS_REQUEST,
  FETCH_COURSE_DETAILS_SUCCESS,
} from "./types";

export const fetchCourseCatalog = () => async (dispatch) => {
  dispatch({ type: FETCH_CATALOG_REQUEST });
  try {
    const response = await api.get(`/courses/catalog`);
    dispatch({ type: FETCH_CATALOG_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: FETCH_CATALOG_FAILURE, payload: error.message });
  }
};

export const fetchCourseDetails = (teacherCourseId) => async (dispatch) => {
  dispatch({ type: FETCH_COURSE_DETAILS_REQUEST });
  try {
    const response = await api.get(`/courses/details/${teacherCourseId}`);
    dispatch({ type: FETCH_COURSE_DETAILS_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: FETCH_COURSE_DETAILS_FAILURE, payload: error.message });
  }
};
